import { jsx, jsxs } from "react/jsx-runtime";
import classnames from "../../utils/classnames.js";
import Col from "../Grid/Col.js";
import "react";
import Row from "../Grid/Row.js";
import './CarCard.css';import '../Grid/Grid.css';/* empty css                */
import Table from "../Table/Table.js";
import Typography from "../Typography/Typography.js";
/* empty css             */
const CarCardTable = ({ items, className }) => {
  return /* @__PURE__ */ jsx("div", { className: classnames("perxis-auto-car-card-table", className), children: /* @__PURE__ */ jsx(Table, { itemKey: "id", items, xs: 24, children: ({ name, value }) => /* @__PURE__ */ jsxs(Row, { gutter: 5, className: classnames("perxis-auto-car-card-table__item"), wrap: false, children: [
    /* @__PURE__ */ jsx(Col, { span: 12, children: /* @__PURE__ */ jsx(Typography.Text, { level: "main", color: "dark", className: classnames("perxis-auto-car-card-table__item-name"), children: name }) }),
    /* @__PURE__ */ jsx(Col, { span: 12, children: /* @__PURE__ */ jsx(Typography.Text, { level: "main", color: "darkest", className: classnames("perxis-auto-car-card-table__item-value"), children: value }) })
  ] }) }) });
};
export {
  CarCardTable as default
};
//# sourceMappingURL=CarCardTable.js.map
